export const iPvTargets = [
  { id: "ipv4", name: "IPv4" },
  { id: "ipv6", name: "IPv6" }
];

export const nwTestData = [
  { id: "ping4", name: "Ping4" },
  { id: "ping6", name: "Ping6" },
  { id: "traceroute4", name: "TraceRoute4" },
  { id: "traceroute6", name: "TraceRoute6" },
  { id: "netscan", name: "NetScan" }
];

export const transTestData = [
  { id: "maxthroughput", name: "Max Throughput" },
  { id: "uptime", name: "Uptime" },
  { id: "customdata", name: "Custom Data" },
  { id: "cabledata", name: "Cable Data" },
  { id: "webdata", name: "Web Data" },
  { id: "voipdata", name: "VoIP Data" },
  { id: "videodata", name: "Video Data" },
  { id: "cctvdata", name: "CCTV Data" }
];
export const wireTestData = [
  { id: "wiremapcustomcables", name: "Wiremap Custom Cables" },
  { id: "wiremap", name: "Wiremap" }
];
export const poeTestData = [{ id: "poeload", name: "PoE Load" }];
export const fiberTestData = [{ id: "fiberlengthloss", name: "Fiber Length & Loss" }];



// WEBPACK FOOTER //
// ./src/components/subtestsettings/subtestenum.js